import axios from 'axios';
import React, { useState } from 'react'
import { toast } from 'react-toastify';
import RecieptTemplate from "../recieptTemplate";
import ReactDOMServer from 'react-dom/server';
import html2pdf from "html2pdf.js"

const RecieptButton = ({elem}) => {
    const [recieptisLoading, setRecieptisLoading] = useState(false);
    const handleRecieptData = async (invoiceId) => {
        setRecieptisLoading(true)
        try {
            const accessToken = localStorage.getItem("Key");
            const resp = await axios
                .get(`${process.env.REACT_APP_BASE_URL}generate-invoice/${invoiceId}`, {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                })
                .then((response) => {
                    downloadReciept(response.data.data, invoiceId)
                    setRecieptisLoading(false)
                });
        } catch (error) {
            toast("Invoice Generation Failed, Please try again later")
            setRecieptisLoading(false)
            console.log(error);
        }
    };


    const downloadReciept = (data, invoiceId) => {
        setRecieptisLoading(true)
        if (data) {
            console.log(data)
            const element = ReactDOMServer.renderToString(<RecieptTemplate data={data} />);
            const opt = {
                margin: 10,
                filename: `RT${invoiceId}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).save();
        }
        setRecieptisLoading(false)
    }

    return (
        <>
            {recieptisLoading ?
                <button disabled className="btn btn-gradient-success btn-sm">Downloading...</button> :
                <button onClick={() => handleRecieptData(elem.id)} className="btn btn-gradient-success btn-sm" disabled={elem.status!=="PAID"} >Reciept</button>}
        </>
    )
}

export default RecieptButton